import { Product } from '../model/account-group/product.model';
import { AccountGroup } from '../model/account-group/account-group.model';

/**
 * Function returns true if enabled flag on all products is same.
 *
 * Comparison is done by index as modifiedProducts is just a copy of originalProducts.
 *
 * @param {Product[]} originalProducts
 * @param {Product[]} modifiedProducts
 * @return {boolean} true if the flags of corresponding products are same
 */
export const equalEnabledOnProducts = (originalProducts: Product[], modifiedProducts: Product[]): boolean => {
    if (!originalProducts  ||  originalProducts.length === 0) {
        return true; // no products => there can't be any changes on them
    }

    if (originalProducts.length !== modifiedProducts.length) {
        throw new Error('Length must be same.');
    }

    return originalProducts.every((product, index) => product.enabled === modifiedProducts[index].enabled);
};

/**
 * Function returns true if enabled flag on all account groups products is same.
 *
 * Comparison is done by index as modifiedGroups is just a copy of originalGroups.
 *
 * @param {AccountGroup[]} originalGroups
 * @param {AccountGroup[]} modifiedGroups
 * @return {boolean} true if the flags of corresponding products on corresponding account groups are same
 */
export const equalEnabledOnAccountGroups = (originalGroups: AccountGroup[], modifiedGroups: AccountGroup[]): boolean => {
    if (!modifiedGroups) {
        return true;
    }

    if (originalGroups.length !== modifiedGroups.length) {
        throw new Error('Length must be same.');
    }

    return originalGroups.every((originalGroup, index) => equalEnabledOnProducts(originalGroup.products, modifiedGroups[index].products));
};

/**
 * Function checks if all products are disabled on given account group.
 *
 * @param {AccountGroup} group account group
 * @return {boolean} true if all products are disabled; false otherwise
 */
export const allProductsDisabledOnGroup = (group: AccountGroup): boolean => {
    if (!group  ||  !group.products) {
        return true;
    }

    return group.products.every(product => !product  ||  !product.enabled);
};

/**
 *
 * Function checks if all products on all account groups are disabled.
 *
 * @param {AccountGroup[]} groups account groups
 * @return {boolean} true if all products are disabled; false otherwise
 */
export const allProductsDisabled = (groups: AccountGroup[]): boolean => {
    if (!groups) {
        return true;
    }

    return groups.every(group => this.allProductsDisabledOnGroup(group));
};

/**
 * Function copy shown flag from src to dest, so that expanded account groups remain expanded after reverting changes.
 * @param {AccountGroup[]} src source
 * @param {AccountGroup[]} dest destination
 */
export const copyShown = (src: AccountGroup[], dest: AccountGroup[]): AccountGroup[] => {
    return src.map((srcGroup, index) => {
        return {...dest[index], shown: srcGroup.shown};
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/helpers/account-group.helper.ts